import { render, staticRenderFns } from "./TotalWarehouse.vue?vue&type=template&id=146235e2"
import script from "./TotalWarehouse.vue?vue&type=script&lang=js"
export * from "./TotalWarehouse.vue?vue&type=script&lang=js"
import style0 from "./TotalWarehouse.vue?vue&type=style&index=0&id=146235e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports